var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"jumbotron"},[(!_vm.resetPassword)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 offset-md-2"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.message))])])])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }